window.timber = window.timber || {};

timber.init = function () {
  timber.loginForms();
};

timber.getHash = function () {
  return window.location.hash;
};

timber.loginForms = function () {
  var $customerLoginForm = $('#CustomerLoginForm');
  if (!$customerLoginForm.length) {
    return;
  }

  var $recoverPasswordLink = $('#RecoverPassword');
  var $hideRecoverPasswordLink = $('#HideRecoverPasswordLink');
  var $recoverPasswordForm = $('#RecoverPasswordForm');

  function showRecoverPasswordForm() {
    $recoverPasswordForm.show().attr('aria-hidden', 'false');
    $customerLoginForm.hide().attr('aria-hidden', 'true');
    $recoverPasswordLink.attr('aria-expanded', 'true');
    $('#RecoverEmail').trigger('focus');
  }

  function hideRecoverPasswordForm() {
    $recoverPasswordForm.hide().attr('aria-hidden', 'true');
    $customerLoginForm.show().attr('aria-hidden', 'false');
    $recoverPasswordLink.attr('aria-expanded', 'false').trigger('focus');
  }

  $recoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  $hideRecoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() === '#recover') {
    showRecoverPasswordForm();
  }
};

// Initialize Timber's JS on docready
$(timber.init);

